import React, { useState } from "react";
import Stocks from "./Stocks";
import Inventaire from "./Inventaire";
import { useTranslation } from "react-i18next";

const StockTabs = () => {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState("stocks");

  const tabs = [
    {
      id: "stocks",
      label: t("Stocks"),
      icon: "fa-boxes",
      component: <Stocks />,
    },
    {
      id: "inventaire",
      label: t("Inventaire"),
      icon: "fa-clipboard-check",
      component: <Inventaire />,
    },
  ];

  return (
    <section className="">
      <div className="box">
        <div className="box-body">
          {/* Tabs Navigation */}
          <div className="row mb-4">
            <div className="col-12">
              <div className="theme-info nav-tabs-wrapper">
                <ul className="nav nav-tabs nav-justified">
                  {tabs.map((tab) => (
                    <li className="nav-item" key={tab.id}>
                      <button
                        className={`nav-link ${
                          activeTab === tab.id ? "active" : ""
                        }`}
                        style={{ width: "100%" }}
                        onClick={() => setActiveTab(tab.id)}
                      >
                        <i className={`fa ${tab.icon} mr-2`}></i>
                        {tab.label}
                      </button>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>

          {/* Tab Content */}
          <div className="row">
            <div className="col-12">
              <div className="tab-content">
                {tabs.map(
                  (tab) =>
                    activeTab === tab.id && (
                      <div key={tab.id} className="tab-pane fade show active">
                        {tab.component}
                      </div>
                    )
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

    </section>
  );
};

export default StockTabs;
